import moment from 'moment';
import { CURRENT_DATE } from './constants';

export function formatDate(date, format = 'DD/MM/YYYY') {
  if (!date) {
    return null;
  }

  return moment(date, 'DD/MM/YYYY').format(format);
}

export function parseDate(str) {
  if (!str || !moment(str, 'DD/MM/YYYY', true).isValid()) {
    return undefined;
  }

  const d = new Date();
  const defaultMonth = d.getMonth();
  const defaultDay = d.getDay();

  const dateArr = str.split('/');

  const day = dateArr[0] ? parseInt(dateArr[0], 10) : defaultDay;
  const month = dateArr[1] ? parseInt(dateArr[1], 10) - 1 : defaultMonth;
  const year = dateArr[2] ? parseInt(dateArr[2], 10) : '';

  return new Date(year, month, day);
}

export function dateToString(value) {
  const d = new Date(value);
  const date = d.getDate() < 10 ? `0${d.getDate()}` : d.getDate();
  const month = d.getMonth() < 9 ? `0${d.getMonth() + 1}` : (d.getMonth() + 1);
  const year = d.getFullYear();

  return `${date}/${month}/${year}`;
}

export function stringToMoment(value = '') {
  return moment(value, 'DD/MM/YYYY');
}

export function stringToDate(value) {
  return stringToMoment(value).toDate();
}

export function normalizeDateMonth(date) {
  if (!date) {
    return null;
  }
  const startDateArray = date.split('/');
  const day = startDateArray[0];
  const month = startDateArray[1];
  const year = startDateArray[2] && startDateArray[2].length === 4 ? startDateArray[2] : startDateArray[2].substring(0, 4);

  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const monthIndex = parseInt(month, 10) - 1;

  return `${day}/${monthNames[monthIndex]}/${year}`;
}

export function firstDayOfPreviousMonth() {
  const date = new Date();
  date.setMonth(date.getMonth() - 1, 1);
  return date;
}

export function lastDayOfPreviousMonth() {
  const date = new Date(CURRENT_DATE.getTime());
  date.setDate(1);
  date.setDate(date.getDate() - 1);
  return date;
}

export function addMonthsToDate(date = '', numberOfMonths = 0) {
  return moment(date, 'DD/MM/YYYY').add(numberOfMonths, 'M');
}

export function isDateAfter(dateToCheckValue = '', dateValue = '') {
  const date = stringToMoment(dateValue);
  const dateToCheck = stringToMoment(dateToCheckValue);
  return dateToCheck.isAfter(date);
}
